import { debugLog } from "./debugHelper";

let backendHost;

let environmentApi = 'local';

//Definition environment api
const API_LOCAL = "http://localhost:7777";
const API_VERCEL = "https://climatec-api.vercel.app";
const API_CONTABO_DOMAIN = "http:///shalomlive.org"
const API_CONTABO_DOMAIN_SECURE = "https://shalomlive.org"
const API_CONTABO_IP = "http://213.136.94.191:7777"
const API_CONTABO_LOCAL = "http://localhost:7777";
const API_CONTABO_LOCAL_IP = "http://127.0.0.1:7777";

const API_CONTABO_COOLIFY = "https://api-teccc.shalomlive.org"
const API_CONTABO_COOLIFY_MAER = "https://api-teccc.convivencia-teccc.com"
const API_CONTABO_COOLIFY_MAER_QA = "https://api-teccc-qa.convivencia-teccc.com"

const reactAppEnvironmentApi = process.env.REACT_APP_ENVIRONMENT_API || 'local';
const reactAppApiUrl = process.env.REACT_APP_API_URL;

if (reactAppApiUrl) {
    environmentApi = reactAppApiUrl;
} else if (reactAppEnvironmentApi === "local"){
    environmentApi = API_LOCAL;
}else if(reactAppEnvironmentApi === "vercel"){
    environmentApi = API_VERCEL;
}else if(reactAppEnvironmentApi === "coolify"){
    environmentApi = API_CONTABO_COOLIFY;
}else if(reactAppEnvironmentApi === "coolify-maer"){
    environmentApi = API_CONTABO_COOLIFY_MAER;
}else if(reactAppEnvironmentApi === "coolify-maer-qa"){
    environmentApi = API_CONTABO_COOLIFY_MAER_QA;
}else if(reactAppEnvironmentApi === "contabo-domain"){
    environmentApi = API_CONTABO_DOMAIN;
}else if(reactAppEnvironmentApi === "contabo-domain-secure"){
    environmentApi = API_CONTABO_DOMAIN_SECURE;
}else if(reactAppEnvironmentApi === "contabo-ip"){
    environmentApi = API_CONTABO_IP;
}else if(reactAppEnvironmentApi === "contabo-local"){
    environmentApi = API_CONTABO_LOCAL;
}else if(reactAppEnvironmentApi === "contabo-local-ip"){
    environmentApi = API_CONTABO_LOCAL_IP;
}

debugLog(':: environmentApi', { 'environmentApi':environmentApi });

backendHost = environmentApi;

//const hostname = window && window.location && window.location.hostname; //localhost
//let protocolDomain = `${window.location.protocol}//`; //http://

//Para realizarse en base al dominio del frontend
/*
if (hostname === "localhost") {
    backendHost = API_VERCEL;
    //backendHost = API_VERCEL;
} else if (hostname === "gestion.planificacion.gob.ec") {
    backendHost = API_VERCEL;
} 
*/

/*
if(currentDomain === 'planificacion.gob.ec'){ //pro
    //scaUrl = 'https://sistemas.planificacion.gob.ec';
    //captchaHost = 'https://captcha.planificacion.gob.ec';
    backendHost = 'https://climatec-api.vercel.app';
    //jasperHost = 'https://servicios.planificacion.gob.ec/jasperserver/rest_v2/reportes'
}else if(currentDomain === '192.168.247.128'){ //pre
    //scaUrl =  `${protocolDomail}192.168.247.xxx`;
    //captchaHost = `${protocolDomail}192.168.247.xxx`;
    backendHost = `${protocolDomail}192.168.247.xxx`;
    //jasperHost = `${protocolDomail}192.168.247.xxx`;
}else if(currentDomain === '192.168.247.72'){ // des
    //scaUrl =  `${protocolDomail}192.168.247.xxx`;
    //captchaHost = `${protocolDomail}192.168.247.xxx`;
    backendHost = `${protocolDomail}192.168.247.139:80887`;
    //jasperHost = `${protocolDomail}192.168.247.xxx`;
}else if(hostname === 'localhost'){
    //scaUrl =  `${protocolDomail}192.168.247.xxx`;
    //captchaHost = `${protocolDomail}192.168.247.xxx`;
    backendHost = `${protocolDomail}192.168.247.139:80887`;
    //jasperHost = `${protocolDomail}192.168.247.xxx`;
}
*/

export const API_ROOT = `${backendHost}`;
//export const JASPER_ROOT = `${jasperHost}`;
//export const SCA_ROOT = `${scaUrl}`;
//export const CAPTCHA_ROOT = `${captchaHost}`;
